angular.module("app").controller("LiveCasinoPageController", [
    '$scope',
    '$cookies',
    '$window',
    '$templateRequest',
    '$interpolate',
    '$timeout',
    '$controller',
    'preloadedProviders',
    'liveCasinoService',
    'errorHandler',
    'logger',
    'settingsService',
    'preloadedProperties',
    'deepCompare',
    'casinoGameService',
    'backgroundAttachment',
    'liveCasinoPageDefaults',
    'Utils',
    function ($scope, $cookies, $window, $templateRequest, $interpolate, $timeout, $controller,preloadedProviders, liveCasinoService, errorHandler, logger, settingsService,  preloadedProperties, deepCompare, casinoGameService, backgroundAttachment, liveCasinoPageDefaults, Utils) {
            var dependency = {
                '$scope': $scope,
                '$cookies': $cookies,
                '$window': $window,
                '$templateRequest': $templateRequest,
                '$interpolate': $interpolate,
                '$timout': $timeout,
                'preloadedProviders': preloadedProviders,
                'service': liveCasinoService,
                'errorHandler': errorHandler,
                'logger': logger,
                'settingsService': settingsService,
                'preloadedProperties': preloadedProperties,
                'deepCompare': deepCompare,
                'casinoGameService': casinoGameService,
                'backgroundAttachment': backgroundAttachment,
                'builderPageDefaults': liveCasinoPageDefaults,
                'Utils': Utils
            };

            $controller('PageBuilderController', dependency);
    }
]);
